import React from 'react';
import type { ResolvedProps } from 'Cms/tour-practical-information/resolver';
import 'Cms/tour-practical-information/resolver';
import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer';
import { TourInformation } from 'Components/widgets/tour-information/TourInformation';
type TourPracticalInformationLineProps = ResolvedProps;
export const TourPracticalInformationLine = (props: TourPracticalInformationLineProps) => {
  if (!props.resort) {
    return null;
  }

  const {
    resort: {
      practicalInformation: {
        includedInPackage,
        excludedInPackage,
        healthFormalities,
        passportAndVisas,
      },
    },
    immigrationFormalities,
    healthFormalities: healthFormalitiesTitle,
    includedInTour,
    notIncludedInTour,
  } = props;
  const infos = [];

  if (includedInPackage && includedInPackage.length) {
    infos.push({
      title: includedInTour,
      items: includedInPackage,
    });
  }

  if (excludedInPackage && excludedInPackage.length) {
    infos.push({
      title: notIncludedInTour,
      items: excludedInPackage,
    });
  }

  if (passportAndVisas) {
    infos.push({
      title: immigrationFormalities,
      text: passportAndVisas,
    });
  }

  if (healthFormalities) {
    infos.push({
      title: healthFormalitiesTitle,
      text: healthFormalities,
    });
  }

  if (!infos.length) {
    return null;
  }

  return (
    <SiteContainer className="Line">
      <TourInformation infos={infos} />
    </SiteContainer>
  );
};
